import { gql } from 'shared/types/layoutcreator'

export const UPDATE_FEATURE_FLAG = gql(/* GraphQL */ `
  mutation updateFeatureFlag($input: UpdateFeatureFlagInput!) {
    updateFeatureFlag(input: $input) {
      key
      name
      description
      state
      limitedGroupIds
    }
  }
`)
